import angular from 'angular';

import { MenuController } from './controllers/menuController';

import { PricePreviewFilter } from './filters/pricePreviewFilter';

import { MenuService } from './services/menuService';

export const MenuModule = angular
    .module('oo.order.menu', [])
    .controller('MenuController', MenuController)
    .filter('pricePreview', PricePreviewFilter)
    .service('menuService', MenuService)
    .name;
